/**
 * Index membership lookup against literal sets (plan §0.3 Finding 2).
 * SPX is unconditional. Product code uses the normalized NDX spelling.
 */
import { normalizeRequestedTicker, type IndexCode } from '@meridian/contracts';

import { DJI_SET, NDX_SET } from '../constants/index-sets';

/**
 * Normalisation is delegated, never re-implemented: a hand-rolled
 * `toUpperCase().replace(/-/g, '.')` omits the ASCII guard, and `toUpperCase` is
 * unicode-aware — `'ıbm'` (U+0131) would fold to `'IBM'` and this function would
 * authoritatively report Dow membership for a string that is not a ticker.
 * Throws `ZodError` on non-ASCII or out-of-bounds input.
 */
export function indexMembership(ticker: string): readonly IndexCode[] {
  const t = normalizeRequestedTicker(ticker);
  const extra: IndexCode[] = [
    ...(DJI_SET.has(t) ? (['DJI'] as const) : []),
    ...(NDX_SET.has(t) ? (['NDX'] as const) : []),
  ];
  return Object.freeze(['SPX', ...extra] as IndexCode[]);
}
